import React from 'react'
import { Button } from 'antd'

import { store as reduxStore } from 'index'

import classNames from 'classnames'

// import { getEmailOptionElem } from 'utils/ui'

import dataManager from 'pages/main/data/DataManager'
import { AvatarImg } from 'pages/main/data/def'
// import { AddressAvatar } from 'pages/main/data/AddressObj'

import mailboxApiHelper from 'services/mailbox-api'

import orgChartHelper from 'pages/contacts/components/OrgChart/Helper'
import contactHelper from 'pages/contacts/components/SharedContacts/Helper'
import * as contactService from 'pages/contacts/modules/contactService'
import { validateEmail } from 'pages/contacts/utils'
import { stringToHash } from 'utils/ui'
import { NameObj, NameSplitter } from 'pages/contacts/utils/NameSplitter'

import EmailSelect from 'pages/main/components/EmailSelect'

import { CONTACT_TYPE } from 'popups/Settings/def'

import iconClose20SVG from 'assets/images/icon-close-20.svg'

import styles from './style.module.scss'

interface SearchSettings {
  useCompanyContact?: boolean
  useOrgchart?: boolean
  useSharedContact?: boolean
  usePersonalContact?: boolean
  useSuggestedContact?: boolean
  orderList?: string[]
}

function getSearchSettings(): SearchSettings {
  const state = reduxStore.getState()
  const { settings } = state as any
  const { recipientsSearchTarget, recipientsSearchResultOrder } = settings.email

  const searchSettings: SearchSettings = {}

  if (recipientsSearchTarget != null) {
    recipientsSearchTarget.forEach((value: string) => {
      switch (value) {
        case CONTACT_TYPE.COMPANY:
          searchSettings.useCompanyContact = true
          break
        case CONTACT_TYPE.ORGANIZATION:
          searchSettings.useOrgchart = true
          break
        case CONTACT_TYPE.CUSTOMER:
          searchSettings.useSharedContact = true
          break
        case CONTACT_TYPE.PERSONAL:
          searchSettings.usePersonalContact = true
          break
        case CONTACT_TYPE.SUGGESTED:
          searchSettings.useSuggestedContact = true
          break
        default:
      }
    })
  } else {
    searchSettings.useCompanyContact = true
    searchSettings.useOrgchart = true
    searchSettings.useSharedContact = true
    searchSettings.useSuggestedContact = true
  }

  if (recipientsSearchResultOrder != null) {
    const validIndexList = Object.keys(CONTACT_TYPE.typeDef).map((key) => {
      return (CONTACT_TYPE.typeDef as any)[key].value
    })

    // 존재하지 않는 항목 제거.
    const orderList = [...recipientsSearchResultOrder].filter((value: string) => {
      return validIndexList.indexOf(value) > -1 && recipientsSearchTarget.indexOf(value) > -1
    })

    // 정렬 순서에 빠진 항목 추가.
    recipientsSearchTarget.forEach((value: string) => {
      if (orderList.indexOf(value) < -1) {
        orderList.push(value)
      }
    })

    searchSettings.orderList = orderList
  } else {
    searchSettings.orderList = [
      CONTACT_TYPE.COMPANY,
      CONTACT_TYPE.ORGANIZATION,
      CONTACT_TYPE.CUSTOMER,
      CONTACT_TYPE.PERSONAL,
      CONTACT_TYPE.SUGGESTED,
    ]
  }

  return searchSettings
}

interface ContactData {
  name?: string
  email: string
  type?: string
}

class SearchHelper {
  myInfo: any = null
  allSuggestedContactList: ContactData[] = []
  allOrgChartList: ContactData[] = []

  loadSearchData = async () => {
    const reduxState = reduxStore.getState()

    const { user } = reduxState as any

    this.myInfo = {
      name: user.name,
      email: user.email,
    }

    this.allSuggestedContactList = []
    this.allOrgChartList = []

    const searchSettings = getSearchSettings()

    // 검색을 위한 Suggested Contact 정보 로드.
    if (searchSettings.useSuggestedContact === true) {
      const ret = await dataManager.getTempEmailList()
      const dataList = ret.dataList.map((item: any) => {
        return item.data
      })

      this.allSuggestedContactList = [...dataList]
    } else {
      this.allSuggestedContactList = []
    }

    // 검색을 위한 OrgChart 정보 로드.
    if (searchSettings.useOrgchart === true) {
      console.log(' - get_org_chart - startLoading orgChart')
      const orgChartData = await orgChartHelper.startLoading()
      if (orgChartData != null) {
        const { users } = orgChartData

        this.allOrgChartList = users.map((item: any) => {
          // console.log(' - orgUser : ', item)
          const { display_name: displayName, email } = item.data
          // const avatar = orgChartHelper.getAvatarUrl(item)
          return { name: displayName, email }
        })
      }
    } else {
      this.allOrgChartList = []
    }
  }

  searchRecipients = async (
    type: string,
    text: string,
    limit: number,
    exactEmail: boolean,
  ): Promise<ContactData[]> => {
    let result: ContactData[] = []

    switch (type) {
      case CONTACT_TYPE.COMPANY:
        result = await this.searchCompanyContact(text, limit, exactEmail)
        break
      case CONTACT_TYPE.ORGANIZATION:
        result = await this.searchOrgChart(text, limit, exactEmail)
        break
      case CONTACT_TYPE.CUSTOMER:
        result = await this.searchSharedContact(text, limit, exactEmail)
        break
      case CONTACT_TYPE.PERSONAL:
        result = await this.searchPersonalContact(text, limit, exactEmail)
        break
      case CONTACT_TYPE.SUGGESTED:
        result = await this.searchSuggestedContact(text, limit, exactEmail)
        break
      default:
        result = []
    }

    return result
  }

  checkValid = (data: ContactData, text: string, exactEmail: boolean) => {
    const { email, name } = data
    if (exactEmail === true) {
      return email === text
    }
    if (name != null && name.indexOf(text) > -1) {
      return true
    }
    return email.indexOf(text) > -1
  }

  searchFromDataList = async (
    dataList: ContactData[],
    text: string,
    limit: number,
    exactEmail: boolean,
  ): Promise<ContactData[]> => {
    let searchResult = [...dataList]

    if (text != null && text.length > 0) {
      const result: ContactData[] = []
      searchResult.some((data) => {
        if (this.checkValid(data, text, exactEmail)) {
          result.push(data)
        }
        if (limit != null) {
          return result.length >= limit
        }
        return false
      })
      searchResult = result
    }

    if (limit != null) {
      searchResult = searchResult.slice(0, limit)
    }

    return Promise.resolve(searchResult)
  }

  // name, email 형식으로 반환.
  searchOrgChart = async (
    text: string,
    limit: number,
    exactEmail: boolean,
  ): Promise<ContactData[]> => {
    return await this.searchFromDataList(
      this.allOrgChartList.map((item) => {
        return {
          ...item,
          type: CONTACT_TYPE.ORGANIZATION,
        }
      }),
      text,
      limit,
      exactEmail,
    )
  }

  // name, email 형식으로 반환.
  searchSharedContact = async (
    text: string,
    limit: number,
    exactEmail: boolean,
  ): Promise<ContactData[]> => {
    console.log(' - searchSharedContact : ', text)

    const params: any = {
      brief: false,
    }

    if (exactEmail === true) {
      params.email = text
    } else if (text != null && text.length > 0) {
      params.offset = 0
      params.limit = limit != null ? limit : 15
      params.search = text
    }

    let data: any[] = []
    try {
      const res = await contactHelper.contactList(params)

      const { data: contactData, code } = res.data
      data = contactData

      if (code !== 200) {
        return []
      }
    } catch (err) {
      console.log(err)
      return []
    }

    const resultList: ContactData[] = []

    data.forEach((item) => {
      const { person, emails } = item

      let name = null
      if (person != null) {
        const nameObj = new NameObj({
          prefix: person.prefix,
          first_name: person.first_name,
          last_name: person.last_name,
          middle_name: person.middle_name,
          suffix: person.suffix,
        })
        const nameSplitter = new NameSplitter(navigator.language || 'en-US')
        nameSplitter.guessFullNameStyle(nameObj)
        name = nameSplitter.joinWithName(nameObj, true, true)
      }

      emails.forEach((emailItem: any) => {
        const { email } = emailItem
        if (exactEmail !== true || email === text) {
          resultList.push({
            name: name || undefined,
            email,
          })
        }
      })
    })

    return resultList.map((item) => {
      return {
        ...item,
        type: CONTACT_TYPE.CUSTOMER,
      }
    })
  }

  searchPersonalContact = async (
    text: string,
    limit: number,
    exactEmail: boolean,
  ): Promise<ContactData[]> => {
    console.log(' - personalContact : ', text)

    const params: any = {}

    if (text != null && text.length > 0) {
      params.str = text
    }

    let result: ContactData[] = []

    try {
      let res: any[] = []

      if (exactEmail === true) {
        res = await contactService.searchContactByEmail(text, limit)
      } else {
        res = await contactService.searchContactNameEmail(text, limit)
      }

      res.forEach((item: any) => {
        const name = item.contact.person.display_name
        const emails = item.contact.emails

        emails?.forEach((emailItem: any) => {
          const { email } = emailItem

          if (email && validateEmail(email)) {
            if (exactEmail === true) {
              if (email === text) {
                result.push({
                  name,
                  email,
                })
              }
            } else {
              result.push({
                name,
                email,
              })
            }
          }
        })
      })
    } catch (error) {
      console.log(' - error : ', error)
    }

    return result.map((item) => {
      return {
        ...item,
        type: CONTACT_TYPE.PERSONAL,
      }
    })
  }

  searchCompanyContact = async (
    text: string,
    limit: number,
    exactEmail: boolean,
  ): Promise<ContactData[]> => {
    console.log(' - personalContact : ', text)

    const params: any = {}

    if (text != null && text.length > 0) {
      params.str = text
    }

    let result: ContactData[] = []

    try {
      const res = await mailboxApiHelper.getRecipients(params)

      console.log(' - res : ', res)

      result = res
        .filter((item: any) => {
          const { email } = item
          if (exactEmail === true) {
            return email === text
          }
          return true
        })
        .map((item: any) => {
          return {
            ...item,
            type: CONTACT_TYPE.COMPANY,
          }
        })
    } catch (error) {
      console.log(' - error : ', error)
    }

    return result
  }

  // name, email 형식으로 반환.
  searchSuggestedContact = async (
    text: string,
    limit: number,
    exactEmail: boolean,
  ): Promise<ContactData[]> => {
    return await this.searchFromDataList(
      this.allSuggestedContactList.map((item) => {
        return {
          ...item,
          type: CONTACT_TYPE.SUGGESTED,
        }
      }),
      text,
      limit,
      exactEmail,
    )
  }

  search = async (text: string, exactEmail: boolean): Promise<ContactData[]> => {
    console.log(' - search : ', text)
    // console.log(text);
    // let className = classNames(styles.notEmail);

    let resultList: ContactData[] = []
    const resultMap: Record<string, ContactData> = {}

    const limit = 15
    let remain = 15

    const searchSettings = getSearchSettings()

    let idx = 0
    while (remain > 0 && idx < (searchSettings.orderList?.length || 0)) {
      const type = searchSettings.orderList![idx]
      const ret = await this.searchRecipients(type, text, remain, exactEmail)
      ret.forEach((item) => {
        const { email, name } = item
        const nameKey = name != null && name.length > 0 ? stringToHash(name) : ''
        const key = `${email}=${nameKey}`
        if (resultMap[key] == null) {
          resultMap[key] = item
          resultList.push(item)
        }
      })
      remain = limit - resultList.length
      idx += 1
    }

    if (resultList.length > 15) {
      resultList = resultList.slice(0, 15)
    }

    return resultList
  }

  tempEmailChanged = () => {
    searchHelper.loadSearchData()
  }
}

export const searchHelper = new SearchHelper()

dataManager.tempEmailListener.add(searchHelper.tempEmailChanged)

interface SharedEmailSelectProps {
  overlayClassName?: string
  innerDomain?: string
  innerRef?: any
  initialFocus?: boolean
  placeholder?: string
  onChange?: (refCurrent: any, userInfoList: any, isDeleted: boolean) => void
  disabled?: boolean
  maxCount?: number
  dataTestId?: string
}

class SharedEmailSelect extends React.Component<SharedEmailSelectProps> {
  emailInfo: Record<string, any> = {}

  emailOptions: any[] = []

  myInfo: any = null

  allOrgChartList: any[] = []

  allSuggestedContactList: any[] = []

  async componentDidMount() {
    await searchHelper.loadSearchData()
  }

  getOption = (name: string | undefined, email: string, type: string) => {
    const nameKey = name != null && name.length > 0 ? stringToHash(name) : ''
    const key = `${email}=${nameKey}`
    let deleteElem = null
    if (type === CONTACT_TYPE.SUGGESTED) {
      deleteElem = (
        <Button
          type="text"
          className={classNames(styles.delete)}
          onClick={(e: any) => this.deleteSuggestedContact(e, email)}
          icon={<img src={iconClose20SVG} alt="delete" />}
        />
      )
    }

    const emailSetProps = {
      className: classNames('emailSet', { enableDelete: type === CONTACT_TYPE.SUGGESTED }),
    }

    return {
      key,
      label: (
        <div {...emailSetProps}>
          <div className="avatar">
            <AvatarImg email={email} name={name} />
          </div>
          <div className="name">{name}</div>
          <div className="email">{email}</div>
          {deleteElem}
        </div>
      ),
      value: key,
      email,
      name,
    }
  }

  deleteSuggestedContact = (e: any, email: string) => {
    console.log('deleteSuggestedContact - ', email)

    dataManager.deleteTempEmail(email).then(() => {
      searchHelper.loadSearchData()
    })

    e.preventDefault()
    e.stopPropagation()
  }

  search = async (text: string, exactEmail: boolean) => {
    const resultList = await searchHelper.search(text, exactEmail)

    return resultList.map((item) => {
      const { email, name, type } = item
      return this.getOption(name, email, type || '')
    })
  }

  render() {
    const {
      overlayClassName,
      innerDomain,
      innerRef,
      initialFocus,
      placeholder,
      onChange,
      disabled,
      maxCount,
      dataTestId,
    } = this.props

    const EmailSelectAny = EmailSelect as any

    return (
      <EmailSelectAny
        overlayClassName={classNames(styles.emailSelectPopup, overlayClassName)}
        innerRef={innerRef}
        innerDomain={innerDomain}
        search={this.search}
        initialFocus={initialFocus}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        maxCount={maxCount}
        dataTestId={dataTestId}
      />
    )
  }
}

export default SharedEmailSelect
